import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown'
import React, { Component } from 'react'
import ButtonPlanComponent from '../../pages/results/button'
import garanty from '../../assets/img/garanty.webp'
import './finalcta.css'
export default class FinalCtaComponent extends Component {
  targetTime = Date.now() + 60 * 3600 * 1000
  render() {
    return (
      <div className="finalcta-container">
        <section className="final-offer">
          <p>Esta oferta desaparece cuando el contador llegue a cero</p>
          <FlipClockCountdown
            to={this.targetTime}
            labels={['Días', 'Horas', 'Minutos', 'Segundos']}
            renderMap={[false, false, true, true]}
            digitBlockStyle={{ backgroundColor: 'darkgray' }}
          />
          <p className="final-info">
            Una consulta privada con un buen nutricionista podría superar
            fácilmente los <strong>$100</strong>.
            <br /> Aquí tienes todo, sin riesgos o efectos secundarios, por:
          </p>

          <div className="price-box">
            <p className="price-before">
              Antes <span>$197</span>
            </p>
            <p className="price-now">
              Hoy <strong>$97</strong> pago único
            </p>
            <p className="price-warning">El precio subirá pronto.</p>
          </div>

          <ButtonPlanComponent></ButtonPlanComponent>
          <p>Obten todo el plan con un solo pago, sin mensualidades ni cuotas ocultas</p>

          <img src={garanty} alt="100% garantia" />
          <h5>Pruébalo sin riesgo durante 30 días.</h5>
          <p>Si no sientes que es para ti, no lo pagas. Así de simple.</p>
        </section>
        <section class="motivational-dynamic">
          <div class="motivational-wrapper">
            <p class="line big gradient">No necesitas más motivación.</p>
            <p class="line medium">
              Necesitas una estrategia diseñada para tu biología.
            </p>
            <p class="line italic small">Miles ya lo hicieron.</p>
            <p class="line medium">Ahora tú decides si sigues igual…</p>
            <p class="line huge gradient">o empiezas diferente.</p>
          </div>
          <div>
 <p className="price-now">
              <strong>$97</strong> pago único
            </p>
          <ButtonPlanComponent></ButtonPlanComponent>
          
          <p>Obten todo el plan con un solo pago, sin mensualidades ni cuotas ocultas</p>
          </div>
        </section>
      </div>
    )
  }
}
